module.exports = __webpack_public_path__ + "static/media/icon_178.a8719ac3.svg";